import type { ApplicationParticipantsResponse } from '@acme/api';
import { Field, renderFieldIfText } from '@acme/foundation';

export const ApplicationParticipants = ({
  participants,
  applicationId,
}: {
  participants: ApplicationParticipantsResponse | null;
  applicationId?: string;
}) => {
  if (!participants?.client) return null;

  const org = participants.client.organization;
  const clientPageLink =
    applicationId != null && applicationId !== ''
      ? `/application/${applicationId}/client`
      : undefined;
  const contact = participants.client.contactUser;
  const contactPageLink =
    applicationId != null && applicationId !== ''
      ? `/application/${applicationId}/client`
      : undefined;

  return (
    <div className="grid grid-cols-3 gap-6">
      {clientPageLink && org?.name ? (
        <Field label="Клиент" value={org.name} link={clientPageLink} />
      ) : (
        renderFieldIfText('Клиент', org?.name)
      )}
      {contactPageLink && contact?.name ? (
        <Field
          label="Контактное лицо клиента"
          value={contact.name}
          link={contactPageLink}
        />
      ) : (
        renderFieldIfText('Контактное лицо клиента', contact?.name)
      )}
    </div>
  );
};
